import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Header, Segment, List, Form, Input, Button, Modal, Table, Icon, Dropdown, Grid } from 'semantic-ui-react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { setActivePage, getProductPricing, getBookletPricing, getProductMaterials, updateProductMaterials, getMaterialList } from '../actions';

// helper function to reorder item
const reorderList = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

// helper function to delete item
const deleteItem = (list, index) => {
    const result = Array.from(list);
    result.splice(index, 1);

    return result;
};

class Misc extends Component {
    constructor(props) {
        super(props);
        props.getProductMaterials();
        props.getMaterialList('paper');
        // props.getBookletPricing('Digital Booklet');
        this.state = {
            openModal: false,
            materials: null,
            materialList: {},
            selectedProduct: '',
            selectedPart: '',
            newPaperType: ''
        }
    }

    componentDidUpdate(previousProps, previousState) {
        if (this.props.product.materials !== previousProps.product.materials) {
            this.setState({ materials: this.props.product.materials, openModal: false });
        }

        if (this.props.product.material_list !== previousProps.product.material_list) {
            this.setState({ materialList: this.props.product.material_list });
        }
    }

    componentDidMount() {
        this.props.setActivePage('misc');
    }

    // List item manipulation for products except booklets
    handleMoveItem(name, index, direction) {
        let materials = Array.from(this.props.product.materials);
        if (materials) {
            let found = materials.findIndex(el => el.name === name);
            if (found > -1) {
                let length = materials[found].material.values.length;
                let new_index = (index + direction + length) % length;
                let new_order = reorderList(materials[found].material.values, index, new_index);
                materials[found].material.values = new_order;
                this.props.updateProductMaterials(materials);
            }
        }
    }

    handleDeleteItem(name, index) {
        let materials = Array.from(this.props.product.materials);
        if (materials) {
            let found = materials.findIndex(el => el.name === name);
            if (found > -1) {
                let new_list = deleteItem(materials[found].material.values, index);
                materials[found].material.values = new_list;
                this.props.updateProductMaterials(materials);
            }
        }
    }

    // List item manipulation for booklets
    handleMoveBookletItem(name, part, index, direction) {
        let materials = Array.from(this.props.product.materials);
        if (materials) {
            let found = materials.findIndex(el => el.name === name);
            if (found > -1) {
                let length = materials[found][part].values.length;
                let new_index = (index + direction + length) % length;
                let new_order = reorderList(materials[found][part].values, index, new_index);
                materials[found][part].values = new_order;
                this.props.updateProductMaterials(materials);
            }
        }
    }

    handleDeleteBookletItem(name, part, index) {
        let materials = Array.from(this.props.product.materials);
        if (materials) {
            let found = materials.findIndex(el => el.name === name);
            if (found > -1) {
                let new_list = deleteItem(materials[found][part].values, index);
                materials[found][part].values = new_list;
                this.props.updateProductMaterials(materials);
            }
        }
    }

    handlePaperInput(evt, { value }) {
        this.setState({ newPaperType: value });
    }

    handleAddItem(product, part) {
        if (product.includes('Digital Booklet')) {
            this.props.getBookletPricing(product);
        } else {
            this.props.getProductPricing(product);
        }
        this.setState({ selectedProduct: product, selectedPart: part, newPaperType: '', openModal: true });
    }

    handleConfirmAdd() {
        if (this.state.selectedProduct.includes('Digital Booklet')) {
            if ((this.state.selectedPart.length > 0) && (this.state.newPaperType.length > 0)) {
                let newMaterials = Array.from(this.state.materials);
                let productIndex = this.state.materials.findIndex(el => el.name === this.state.selectedProduct);
                newMaterials[productIndex][this.state.selectedPart].values.push(this.state.newPaperType);
                this.props.updateProductMaterials(newMaterials);
            }
        } else if (this.state.selectedProduct === 'Racing Horse Calendar With Header') {
            if ((this.state.selectedPart.length > 0) && (this.state.newPaperType.length > 0)) {
                let newMaterials = Array.from(this.state.materials);
                let productIndex = this.state.materials.findIndex(el => el.name === this.state.selectedProduct);
                newMaterials[productIndex][this.state.selectedPart].values.push(this.state.newPaperType);
                console.log(newMaterials);
                this.props.updateProductMaterials(newMaterials);
            }
        } else {
            if (this.state.newPaperType.length > 0) {
                let newMaterials = Array.from(this.state.materials);
                let productIndex = this.state.materials.findIndex(el => el.name === this.state.selectedProduct);
                newMaterials[productIndex].material.values.push(this.state.newPaperType);
                this.props.updateProductMaterials(newMaterials);
            }
        }
    }

    renderBookletMaterials(product) {
        let cover_output = product.cover_material.values.map((type, index) => {
            return (
                <List.Item key={product._id + 'cover_material' + type}>
                    <List.Content floated='right' verticalAlign='middle'>
                        <Icon link name='arrow up' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'cover_material', index, -1)} />
                        <Icon link name='arrow down' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'cover_material', index, 1)} />
                        <Icon link name='delete' className='cross-hover' onClick={this.handleDeleteBookletItem.bind(this, product.name, 'cover_material', index)} />
                    </List.Content>
                    <List.Header>{type}</List.Header>
                </List.Item>
            )
        });

        let inner_output = product.inner_material.values.map((type, index) => {
            return (
                <List.Item key={product._id + 'inner_material' + type}>
                    <List.Content floated='right' verticalAlign='middle'>
                        <Icon link name='arrow up' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'inner_material', index, -1)} />
                        <Icon link name='arrow down' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'inner_material', index, 1)} />
                        <Icon link name='delete' className='cross-hover' onClick={this.handleDeleteBookletItem.bind(this, product.name, 'inner_material', index)} />
                    </List.Content>
                    <List.Header>{type}</List.Header>
                </List.Item>
            )
        })

        return (
            <Segment raised padded='very' key={product.name}>
                <Header as="h3" textAlign="center">{product.name}</Header>
                <h3>Cover<Button floated='right' onClick={this.handleAddItem.bind(this, product.name, 'cover_material')}>ADD</Button></h3><List ordered divided selection>{cover_output}</List>
                <h3>Inner<Button floated='right' onClick={this.handleAddItem.bind(this, product.name, 'inner_material')}>ADD</Button></h3><List ordered divided selection>{inner_output}</List>
            </Segment>
        );
    }

    renderCalendarMaterials(product) {
        let header_output = product.header_material.values.map((type, index) => {
            return (
                <List.Item key={product._id + 'header_material' + type}>
                    <List.Content floated='right' verticalAlign='middle'>
                        <Icon link name='arrow up' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'header_material', index, -1)} />
                        <Icon link name='arrow down' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'header_material', index, 1)} />
                        <Icon link name='delete' className='cross-hover' onClick={this.handleDeleteBookletItem.bind(this, product.name, 'header_material', index)} />
                    </List.Content>
                    <List.Header>{type}</List.Header>
                </List.Item>
            )
        });

        let inner_output = product.inner_material.values.map((type, index) => {
            return (
                <List.Item key={product._id + 'inner_material' + type}>
                    <List.Content floated='right' verticalAlign='middle'>
                        <Icon link name='arrow up' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'inner_material', index, -1)} />
                        <Icon link name='arrow down' className='arrow-hover' onClick={this.handleMoveBookletItem.bind(this, product.name, 'inner_material', index, 1)} />
                        <Icon link name='delete' className='cross-hover' onClick={this.handleDeleteBookletItem.bind(this, product.name, 'inner_material', index)} />
                    </List.Content>
                    <List.Header>{type}</List.Header>
                </List.Item>
            )
        })

        return (
            <Segment raised padded='very' key={product.name}>
                <Header as="h3" textAlign="center">{product.name}</Header>
                <h3>Header<Button floated='right' onClick={this.handleAddItem.bind(this, product.name, 'header_material')}>ADD</Button></h3><List ordered divided selection>{header_output}</List>
                <h3>Inner<Button floated='right' onClick={this.handleAddItem.bind(this, product.name, 'inner_material')}>ADD</Button></h3><List ordered divided selection>{inner_output}</List>
            </Segment>
        );
    }

    renderMaterials(product) {
        let output = product.material.values.map((type, index) => {
            return (
                <List.Item key={product._id + type}>
                    <List.Content floated='right' verticalAlign='middle'>
                        <Icon link name='arrow up' className='arrow-hover' onClick={this.handleMoveItem.bind(this, product.name, index, -1)} />
                        <Icon link name='arrow down' className='arrow-hover' onClick={this.handleMoveItem.bind(this, product.name, index, 1)} />
                        <Icon link name='delete' className='cross-hover' onClick={this.handleDeleteItem.bind(this, product.name, index)} />
                    </List.Content>
                    <List.Header>{type}</List.Header>
                </List.Item>
            )
        })

        return <Segment raised padded='very' key={product.name}>
            <Header as="h3" textAlign="center">{product.name}<Button floated='right' onClick={this.handleAddItem.bind(this, product.name)}>ADD</Button></Header>
            <List ordered divided selection>{output}</List>
        </Segment>;
    }

    renderPaper(materials) {
        return (
            materials.map((product) => {
                switch (product.name) {
                    case 'Digital Booklet Landscape':
                    case 'Digital Booklet':
                        return this.renderBookletMaterials(product);

                    case 'Racing Horse Calendar With Header':
                        return this.renderCalendarMaterials(product);

                    default:
                        return this.renderMaterials(product);
                }
            })
        )
    }

    render() {
        const { openModal, selectedProduct, materials, materialList } = this.state;

        return (
            <Container>
                <Modal open={openModal}>
                    <Modal.Header>Add Paper Type ({selectedProduct})</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Grid columns={1}>
                                <Grid.Column>
                                    <Input
                                        fluid
                                        placeholder='Enter Paper Type'
                                        list='paper'
                                        onChange={this.handlePaperInput.bind(this)}
                                    />
                                    { materialList.paper &&
                                        <datalist id='paper'>
                                            {
                                                materialList.paper.map(material => <option key={material} value={material} />)
                                            }
                                        </datalist>
                                    }
                                </Grid.Column>
                            </Grid>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ openModal: false })}>
                            Cancel
                        </Button>
                        <Button primary onClick={this.handleConfirmAdd.bind(this)}>
                            CONFIRM
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Header as="h2">Paper</Header>
                {materials &&
                    this.renderPaper(materials)
                }
            </Container>
        )
    }
}

const mapStateToProps = ({ product }) => {
    return { product };
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setActivePage: setActivePage,
        getProductPricing: getProductPricing,
        getBookletPricing: getBookletPricing,
        getProductMaterials: getProductMaterials,
        updateProductMaterials: updateProductMaterials,
        getMaterialList: getMaterialList
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Misc);